import _getIterator from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/core-js/get-iterator';
import _JSON$stringify from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/core-js/json/stringify';
import _regeneratorRuntime from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/helpers/asyncToGenerator';

var get = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(userId) {
    var _ref2, data;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return axios.get('/users/' + userId);

          case 2:
            _ref2 = _context.sent;
            data = _ref2.data;
            return _context.abrupt('return', data);

          case 5:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function get(_x) {
    return _ref.apply(this, arguments);
  };
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import nationality from '~/static/nationality.json';
import workerDesignation from '~/static/userProfile/workerDesignation.json';
import workForceCategory from '~/static/userProfile/workForceCategory.json';
import idType from '~/static/userProfile/idType.json';
import flagType from '~/static/flagType.json';

import axios from '~/plugins/axios.js';

export default {
  // name: "_userId"
  components: {},
  head: function head() {
    return {
      title: 'Editing ' + this.$store.state.report.userEdited.fullname + ' Profile'
    };
  },
  data: function data() {
    return {
      userEdited: JSON.parse(_JSON$stringify(this.$store.state.report.userEdited)),
      idType: idType,
      flagType: flagType,
      userEditedMsManager: null,
      userEditedBookedModuleSession: [],
      removingNricFin: '',
      removingModalTitle: 'Remove User'
    };
  },
  mounted: function mounted() {
    this.getUserEditedBookedModuleSession();
  },
  asyncData: function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
      var store = _ref3.store,
          params = _ref3.params,
          error = _ref3.error;
      var userActor;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return get(params.userId);

            case 2:
              userActor = _context2.sent;

              store.commit('report/setUserEdited', userActor);
              return _context2.abrupt('return', { userActor: userActor });

            case 5:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function asyncData(_x2) {
      return _ref4.apply(this, arguments);
    }

    return asyncData;
  }(),
  fetch: function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref5) {
      var store = _ref5.store,
          redirect = _ref5.redirect,
          context = _ref5.context;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (store.state.authUser) {
                _context3.next = 2;
                break;
              }

              return _context3.abrupt('return', redirect('/'));

            case 2:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function fetch(_x3) {
      return _ref6.apply(this, arguments);
    }

    return fetch;
  }(),

  methods: {
    getUserEditedBookedModuleSession: function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var managerId, manager, bookedModuleSessions, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, msId, moduleSession;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                managerId = 'userMsManager' + this.$store.state.report.userEdited.id;
                _context4.next = 3;
                return axios.post('/userMsManager/obtainSingleManager', { managerId: managerId });

              case 3:
                manager = _context4.sent.data.manager;

                this.userEditedMsManager = manager;
                console.log('\n\n ======= _userId <|-- initialize the manager of this User====== \n', this.userEditedMsManager, '\n --------------');

                bookedModuleSessions = [];

                if (!(this.userEditedMsManager.bookedModules.length !== 0)) {
                  _context4.next = 40;
                  break;
                }

                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context4.prev = 11;
                _iterator = _getIterator(this.userEditedMsManager.bookedModules);

              case 13:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context4.next = 22;
                  break;
                }

                msId = _step.value;
                _context4.next = 17;
                return axios.get('/moduleSession/' + msId);

              case 17:
                moduleSession = _context4.sent.data;

                bookedModuleSessions.push(moduleSession);

              case 19:
                _iteratorNormalCompletion = true;
                _context4.next = 13;
                break;

              case 22:
                _context4.next = 28;
                break;

              case 24:
                _context4.prev = 24;
                _context4.t0 = _context4['catch'](11);
                _didIteratorError = true;
                _iteratorError = _context4.t0;

              case 28:
                _context4.prev = 28;
                _context4.prev = 29;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 31:
                _context4.prev = 31;

                if (!_didIteratorError) {
                  _context4.next = 34;
                  break;
                }

                throw _iteratorError;

              case 34:
                return _context4.finish(31);

              case 35:
                return _context4.finish(28);

              case 36:
                this.userEditedBookedModuleSession = bookedModuleSessions;

                console.log('\n\n ======= _userId <|-- initialize the manager of this User====== \n', this.userEditedBookedModuleSession, '\n --------------');
                _context4.next = 41;
                break;

              case 40:
                console.log('\n\n  ======= _userId <|-- NO MS booked====== \n');

              case 41:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[11, 24, 28, 36], [29,, 31, 35]]);
      }));

      function getUserEditedBookedModuleSession() {
        return _ref7.apply(this, arguments);
      }

      return getUserEditedBookedModuleSession;
    }(),
    editUserInfo: function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var wo_WorkingProfile_UserInfo, editedUserId, testInfo, refreshUser;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                wo_WorkingProfile_UserInfo = JSON.parse(_JSON$stringify(this.userEdited));

                delete wo_WorkingProfile_UserInfo.workingProfile;
                console.log('\n\n ======  _userId <|-- wo_WorkingProfile_UserInfo ====== \n', wo_WorkingProfile_UserInfo, '\n -----------------');

                editedUserId = this.$store.state.report.userEdited.id;
                _context5.next = 6;
                return axios.post('/users/editUserInfo', {
                  editedUserId: editedUserId,
                  wo_WorkingProfile_UserInfo: wo_WorkingProfile_UserInfo
                });

              case 6:
                testInfo = _context5.sent.data;


                console.log('\n\n ======  _userId <|-- updateUserInfo ====== \n', testInfo, '\n -------------------');

                alert('User Info updated ' + testInfo);

                _context5.next = 11;
                return this.initTheUser(editedUserId);

              case 11:
                refreshUser = _context5.sent;

                this.$store.commit('report/setUserEdited', refreshUser);
                this.userEdited = JSON.parse(_JSON$stringify(refreshUser));

              case 14:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function editUserInfo() {
        return _ref8.apply(this, arguments);
      }

      return editUserInfo;
    }(),
    editWorkingProfile: function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var userEditedId, testInfo, refreshUser;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                console.log(this.userEdited.workingProfile);

                userEditedId = this.$store.state.report.userEdited.id;

                console.log(userEditedId);
                _context6.next = 5;
                return axios.post('/users/editUserWorkingProfile', {
                  userEditedId: userEditedId,
                  workingProfile: this.userEdited.workingProfile
                });

              case 5:
                testInfo = _context6.sent.data;


                console.log('\n\n ======  _userId <|-- editUserWorkingProfiles ====== \n', testInfo, '\n -------------------');

                alert('Working Profile updated ' + testInfo);

                _context6.next = 10;
                return this.initTheUser(userEditedId);

              case 10:
                refreshUser = _context6.sent;

                this.$store.commit('report/setUserEdited', refreshUser);
                this.userEdited = JSON.parse(_JSON$stringify(refreshUser));
                // this.userEdited = refreshUser;

              case 13:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function editWorkingProfile() {
        return _ref9.apply(this, arguments);
      }

      return editWorkingProfile;
    }(),
    initTheUser: function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(userEditedId) {
        var userActor;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return axios.get('/users/' + userEditedId);

              case 2:
                userActor = _context7.sent.data;
                return _context7.abrupt('return', userActor);

              case 4:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function initTheUser(_x4) {
        return _ref10.apply(this, arguments);
      }

      return initTheUser;
    }(),
    expandAccordion: function expandAccordion(msAccordionId) {
      this.$root.$emit('bv::toggle::collapse', msAccordionId);
    },
    cancelBooking: function () {
      var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(msId) {
        var userActorId, managerId, moduleSessionActorId, msStatusCode, cancelInfo;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                userActorId = this.$store.state.report.userEdited.id;
                managerId = this.userEditedMsManager.id;
                moduleSessionActorId = msId;
                msStatusCode = 1;


                console.log('\n\n ===== _userId <|-- cancelBooking ==== \n', msId, '\n ------------------');
                _context8.next = 7;
                return axios.post('/userMsManager/unBookModuleSession', {
                  userActorId: userActorId,
                  managerId: managerId,
                  moduleSessionActorId: moduleSessionActorId,
                  msStatusCode: msStatusCode
                });

              case 7:
                cancelInfo = _context8.sent.data;


                console.log('cancelInfo', cancelInfo);
                alert(cancelInfo);
                window.location.reload();

              case 11:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function cancelBooking(_x5) {
        return _ref11.apply(this, arguments);
      }

      return cancelBooking;
    }(),
    popRemoveModal: function () {
      var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(button) {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                this.$root.$emit('bv::show::modal', 'removeCurrentUserModal', button);

              case 1:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function popRemoveModal(_x6) {
        return _ref12.apply(this, arguments);
      }

      return popRemoveModal;
    }(),
    removeUser: function () {
      var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        var removedInfo;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                console.log('\n\n ====== _userId <|-- removeUser() ===== \n', this.userEdited.nricFin === this.removingNricFin, '\n -----------------');

                if (!(this.userEdited.nricFin === this.removingNricFin)) {
                  _context10.next = 8;
                  break;
                }

                _context10.next = 4;
                return axios.post('/users/removeUser', {
                  uId: this.userEdited.id
                });

              case 4:
                removedInfo = _context10.sent.data;

                if (removedInfo == 'Remove User Successful') {
                  alert(removedInfo + '\n' + 'Click OK to close window');
                  window.close();
                } else {
                  alert(removedInfo);
                }
                _context10.next = 10;
                break;

              case 8:
                alert('User nric / fin wrong');
                this.$refs['remove-user' + this.userEdited.nricFin].hide();

              case 10:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function removeUser() {
        return _ref13.apply(this, arguments);
      }

      return removeUser;
    }()
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/home/ubuntu/BookingSystemV2/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/dashboard/registration/_userId.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/home/ubuntu/BookingSystemV2/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/dashboard/registration/_userId.vue
// module chunks = 14